export default __webpack_public_path__ + "static/moon-70ec6a8e5f99f0aaf991ddf21bce65ef.png";